import { generatePath } from 'react-router-dom';
import { DEAL_ROUTES, ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';

export const VALUATIONS_ROUTES = {
	root: ({ dealId }: { dealId: string }) =>
		generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.WATERFALL}`, { dealId: dealId ?? '' }),
	specific: ({ dealId, valuationId }: { dealId: string; valuationId: string }) =>
		generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.WATERFALL_DETAILS}`, {
			dealId: dealId ?? '',
			valuationId,
		}),
	summary: ({ dealId, valuationId }: { dealId: string; valuationId: string }) =>
		generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.WATERFALL_DETAILS}/summary`, {
			dealId: dealId ?? '',
			valuationId,
		}),
	sourcesAndUses: ({
		dealId,
		valuationId,
		personId,
		mipId,
	}: {
		dealId: string;
		valuationId: string;
		personId?: string;
		mipId?: string | null;
	}) => {
		const baseUrl = generatePath(
			`${ROUTES.DEAL}${DEAL_ROUTES.WATERFALL_DETAILS}/sources-and-uses`,
			{
				dealId: dealId ?? '',
				valuationId,
			}
		);
		if (personId) {
			const params = new URLSearchParams();
			params.set('personId', personId);
			if (mipId) {
				params.set('mipId', mipId);
			}
			return `${baseUrl}?${params.toString()}`;
		}
		return baseUrl;
	},
	breakpointSummary: ({
		dealId,
		valuationId,
		personId,
		mipId,
		openDrawer,
	}: {
		dealId: string;
		valuationId: string;
		personId?: string;
		mipId?: string | null;
		openDrawer?: string;
	}) => {
		const baseUrl = generatePath(
			`${ROUTES.DEAL}${DEAL_ROUTES.WATERFALL_DETAILS}/sources-and-uses/breakpoint-summary`,
			{
				dealId: dealId ?? '',
				valuationId,
			}
		);
		const params = new URLSearchParams();
		if (personId) {
			params.set('personId', personId);
		}
		if (mipId) {
			params.set('mipId', mipId);
		}
		if (openDrawer) {
			params.set('openDrawer', openDrawer);
		}
		const queryString = params.toString();
		return queryString ? `${baseUrl}?${queryString}` : baseUrl;
	},
} as const satisfies Record<ValuationLocation, (args: unknown) => string>;

export enum ValuationLocation {
	ROOT = 'root',
	SUMMARY = 'summary',
	SOURCES_AND_USES = 'sourcesAndUses',
	BREAKPOINT_SUMMARY = 'breakpointSummary',
	SPECIFIC = 'specific',
}

export enum ValuationPathPart {
	VALUATIONS = 'valuations',
	SUMMARY = 'summary',
	SOURCES_AND_USES = 'sources-and-uses',
	BREAKPOINT_SUMMARY = 'breakpoint-summary',
}

export const NEW_VALUATION_ID = 'new';
